import moment from "moment";

export const setCookieToken = (token: string) => {
  if (token) {
    document.cookie =
      `X-Authorization=${token}; ` +
      `Expires=${moment()
        .add(1, "days")
        .utc()
        .format("ddd, DD MMM YYYY HH:mm:ss [GMT]")}; ` + // UTC formatında belirleme
      `Path=/; ` + // Cookie tüm siteye erişilebilir olacak
      `Domain=.xsight.paneratech.com; ` + // Tüm subdomain'lerde geçerli olacak
      `Secure; ` + // HTTPS bağlantılarında geçerli olacak
      `SameSite=None`; // Cross-site kullanımına izin verir (Özellikle third-party requests için gerekli)
  }
};

export const removeCookieToken = () => {
  document.cookie =
    `X-Authorization=; ` +
    `Expires=Thu, 01 Jan 1970 00:00:00 GMT; ` + // UTC formatında belirleme
    `Path=/; ` + // Cookie tüm siteye erişilebilir olacak
    `Domain=.xsight.paneratech.com; ` + // Tüm subdomain'lerde geçerli olacak
    `Secure; ` + // HTTPS bağlantılarında geçerli olacak
    `SameSite=None`; //
};
